import { tv } from 'tailwind-variants'

export const infoNote = tv({
  slots: {
    container: 'flex flex-row gap-x-2.5 rounded-lg p-4',
    childrenContainer: 'flex-1',
  },
})
